var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 16C0.977778 16 0.666667 15.8667 0.4 15.6C0.133333 15.3333 0 15.0222 0 14.6667V1.33333C0 0.977778 0.133333 0.666667 0.4 0.4C0.666667 0.133333 0.977778 0 1.33333 0H6.86667C7.23486 0 7.53333 0.298477 7.53333 0.666667C7.53333 1.03486 7.23486 1.33333 6.86667 1.33333H1.33333V14.6667H14.6667V9.13333C14.6667 8.76514 14.9651 8.46667 15.3333 8.46667C15.7015 8.46667 16 8.76514 16 9.13333V14.6667C16 15.0222 15.8667 15.3333 15.6 15.6C15.3333 15.8667 15.0222 16 14.6667 16H1.33333ZM6.30003 10.6555C6.03706 10.9185 5.60993 10.916 5.35007 10.6499C5.09449 10.3883 5.09695 9.96971 5.35559 9.71108L13.7333 1.33333H9.53333C9.16514 1.33333 8.86667 1.03486 8.86667 0.666667C8.86667 0.298477 9.16514 0 9.53333 0H15C15.5523 0 16 0.447715 16 1V6.46667C16 6.83486 15.7015 7.13333 15.3333 7.13333C14.9651 7.13333 14.6667 6.83486 14.6667 6.46667V2.28889L6.30003 10.6555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.0d3a4938a720697f7d637da629b56335.svg";
export { ForwardRef as ReactComponent };